import React from "react";
import { ArrowUpRight } from "lucide-react";
import { fr } from "@/locales/fr";
import { appUrl } from "@/lib/referral";

const APP_SIGNUP = "https://work.voxiumscript.com";

export const PitchMeetingFR = () => {
  const t = fr.pitchMeeting;
  return (
    <section
      className="relative w-full bg-ink overflow-hidden"
      data-testid="pitch-meeting-section-fr"
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-20 bg-gold/40 hidden sm:block" aria-hidden="true" />

      <div className="absolute top-10 left-10 hidden lg:flex flex-col gap-2 opacity-50">
        <span className="block w-1 h-1 rounded-full bg-gold" />
        <span className="block w-1 h-1 rounded-full bg-gold/60" />
      </div>
      <div className="absolute bottom-10 right-10 hidden lg:flex flex-col gap-2 opacity-50">
        <span className="block w-1 h-1 rounded-full bg-gold/60" />
        <span className="block w-1 h-1 rounded-full bg-gold" />
      </div>

      <div className="relative max-w-[60rem] mx-auto px-6 sm:px-10 lg:px-16 py-28 sm:py-36 lg:py-44 text-center">
        <p className="eyebrow text-gold mb-8 sm:mb-10" data-testid="pitch-eyebrow-fr">
          {t.eyebrow}
        </p>

        <h2
          className="display-serif text-creamtext text-5xl sm:text-6xl lg:text-[4.5rem] leading-[1.02] mb-10 sm:mb-12"
          data-testid="pitch-headline-fr"
        >
          {t.headline}
        </h2>

        <p
          className="font-body text-creamtext/85 text-lg sm:text-xl leading-relaxed max-w-prose3 mx-auto mb-8"
          data-testid="pitch-body-fr"
        >
          {t.body}
        </p>

        <p
          className="font-body italic text-creamtext/70 text-base sm:text-lg max-w-prose3 mx-auto mb-6 sm:mb-8"
          data-testid="pitch-frame-fr"
        >
          {t.frame}
        </p>

        <p
          className="font-body italic text-creamtext/85 text-lg sm:text-xl max-w-prose3 mx-auto mb-12 sm:mb-14"
          data-testid="pitch-closing-fr"
        >
          {t.closing}
        </p>

        <a href={appUrl(APP_SIGNUP, { lang: "fr" })} className="btn-gold" data-testid="pitch-cta-fr">
          {t.cta}
          <ArrowUpRight size={16} strokeWidth={2} />
        </a>
      </div>
    </section>
  );
};

export default PitchMeetingFR;
